import {Component, Input} from '@angular/core';
import {Categorie} from '../../../dienst/categorie';
import {ClientCategorie} from '../../client-categorie';
import {Taak} from '../../../dienst/taak';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    selector: 'zah-categorie',
    templateUrl: './client-categorie.component.html',
    styleUrls: ['./client-categorie.component.scss'],
    standalone: false
})
export class ClientCategorieComponent {

  @Input()
  categorie: Categorie;
  @Input()
  clientCategorie: ClientCategorie;

  toggle(taak: Taak, change: MatCheckboxChange): void {
    if (change.checked) {
      this.clientCategorie.add(taak.getId());
    } else {
      this.clientCategorie.remove(taak.getId());
    }
  }

  toggleAll(change: MatCheckboxChange): void {
    if (change.checked) {
      this.clientCategorie.addAll(this.categorie.getTaakIds());
    } else {
      this.clientCategorie.removeAll(this.categorie.getTaakIds());
    }
  }
}
